class Abortable {
  abortControllersMap: Map<string, AbortController>;

  constructor() {
    this.abortControllersMap = new Map();
  }

  set(id: string) {
    this.abort(id); /* if it already exists, abort it before overwriting it */
    const abortController = new AbortController();
    this.abortControllersMap.set(id, abortController);
    return abortController;
  }

  get(id: string) {
    return this.abortControllersMap.get(id);
  }

  abort(id: string, message = 'Navigation') {
    /*
      Note: if you add a custom error message inside abort(), make sure it starts with `AbortError`
      otherwise our connection/helpers.ts Get method won't properly catch the abort
    */
    if (!this?.abortControllersMap) return;
    this.abortControllersMap?.get(id)?.abort(message);
    this.delete(id);
  }

  abortAll(message = 'Navigation') {
    for (const [id, ac] of this.abortControllersMap.entries()) {
      ac.abort(message);
      this.delete(id);
    }
  }

  delete(id: string) {
    this.abortControllersMap.delete(id);
  }

  deleteAll() {
    this.abortControllersMap.clear();
  }
}

export default new Abortable();
